import React from "react";
import API from "../utils/API";

// Section for Utilities and Context
import "./headlinecard.css";


export default function HeadlineCard(props) {

    const handleClick = () => {
        if (props.headline_id) {
            API.trackHeadlineClick(props.headline_id).catch(() => {}); // fire and forget
        }
    };

    return (
        <>
            <a href={props.url} target="_blank" rel="noreferrer" onClick={handleClick}>
            <div className="card headline-card mb-1">
                <div className="card-body">
                    <div>
                        <i className="bi bi-newspaper"/>
                        <span className="headline-publication ms-1">{props.publication}</span>
                    </div>
                    <h5 className="headline-title pt-1 display-6" >{props.title}</h5>
                    <p className="headline-snippet mb-0"></p>
                    <p className="card-text headline-snippet bio-box-text">{props.snippet}</p>
                </div>
            </div>
            </a>
        </>
    )
}
